import { costBreakdownV2WidgetByIdSelector } from "./costBreakdownV2WidgetByIdSelector";
import { RootState } from "../../../../../store";
import { ForecastOption } from "../../../../../../services/cloudchipr.api";

export const costBreakdownV2WidgetForecastOptionSelector = (
  state: RootState,
  widgetId: string,
): ForecastOption | undefined => {
  const data = costBreakdownV2WidgetByIdSelector(state, widgetId);
  if (!data) {
    return;
  }
  return data?.forecast_option;
};
